module.exports = __webpack_public_path__ + "img/user.808ee703.svg";